import React from 'react';
import { Trash2 } from 'lucide-react';
import type { WatchlistViewItem } from './types';
import { Modal, Button } from '../../components/common';
import { useLanguage } from '../../contexts/LanguageContext';

export interface DeleteWatchDialogProps {
  watch: WatchlistViewItem | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const DeleteWatchDialog: React.FC<DeleteWatchDialogProps> = ({
  watch,
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const { t } = useLanguage();
  if (!watch) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('dialog.deleteTitle')} maxWidth="sm">
      <div className="space-y-4">
        <p className="text-xs text-slate-600 dark:text-slate-400 leading-relaxed">
          {t('dialog.deleteDesc', { title: watch.productTitle })}
        </p>

        <div className="flex items-center justify-end gap-2.5 pt-3 border-t border-slate-100 dark:border-slate-800">
          <Button variant="outline" size="sm" onClick={onClose} disabled={isLoading}>
            {t('dialog.cancel')}
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={onConfirm}
            isLoading={isLoading}
            className="gap-1.5"
          >
            <Trash2 className="w-3.5 h-3.5" />
            <span>{t('dialog.confirmDelete')}</span>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
